"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconImagesAndLogos = function IconImagesAndLogos(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M39 4.97H17v22h22zm-1 1v20H18v-20zM31 19l1 1.8a5.67 5.67 0 1 1-5.6-9.8l1.42.38-.38 1.42A3.59 3.59 0 1 0 31 19m-4.52-1.52a3.18 3.18 0 1 0 1.18-4.32 3.2 3.2 0 0 0-1.18 4.32m-13.583-2.643-.01-.01.004-.004 1.164 1.095 1.37-1.456-2.576-2.425-4.216 4.216.01.01-6.35 6.35L.14 24.735l8.882 8.882 4.079 4.09 4.135 4.084.18.172c.311.277.669.508 1.056.68a3.9 3.9 0 0 0 1.41.336c.483.016.95-.06 1.39-.22.473-.175.9-.448 1.253-.801l7.081-7.08 3.062-3.023-2.562-2.562-1.414 1.414 1.137 1.138-1.633 1.613-5.694 5.695 1.094-9.193-9.074.081-.079-3.071h-9.24L2.98 24.744l.723-.712zm8.446 17.142-1.07 8.983a1.7 1.7 0 0 1-.31.018 1.9 1.9 0 0 1-.676-.163 2.1 2.1 0 0 1-.636-.44l-4.138-4.088-4.075-4.085-3.233-3.234h5.29l.08 3.089zm-9.902-11.567a1.5 1.5 0 1 0 2.12 2.122 1.5 1.5 0 0 0-2.12-2.122m.707.707a.5.5 0 1 1 .707.708.5.5 0 0 1-.707-.708",
    clipRule: "evenodd"
  })));
};

export { IconImagesAndLogos, IconImagesAndLogos as default };
